/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CollectionAddIcon = createIcon(
  '0 0 26.6 18.6',
  <>
    <path d="M0 1.3C0 .582.582 0 1.3 0H15.3C16.018 0 16.6.582 16.6 1.3c0 .718-.582 1.3-1.3 1.3H1.3C.582 2.6 0 2.018 0 1.3Z" />
    <path d="M0 7.3C0 6.582.582 6 1.3 6H15.3C16.018 6 16.6 6.582 16.6 7.3c0 .718-.582 1.3-1.3 1.3H1.3C.582 8.6 0 8.018 0 7.3Z" />
    <path d="M1.3 12C.582 12 0 12.582 0 13.3c0 .718.582 1.3 1.3 1.3H11.3c.718 0 1.3-.582 1.3-1.3 0-.718-.582-1.3-1.3-1.3H1.3Z" />
    <path d="M16 13.3c0-.718.582-1.3 1.3-1.3H20V9.3C20 8.582 20.582 8 21.3 8c.718 0 1.3.582 1.3 1.3V12H25.3c.718 0 1.3.582 1.3 1.3 0 .718-.582 1.3-1.3 1.3H22.6V17.3c0 .718-.582 1.3-1.3 1.3-.718 0-1.3-.582-1.3-1.3V14.6H17.3c-.718 0-1.3-.582-1.3-1.3Z" />
  </>,
);
